<!-- Access Denied Container -->
<div class="access-denied-container">
  <div class="access-denied-content">
    
    <!-- Error Icon -->
    <div class="error-icon">
      <div class="shield-icon">🛡️</div>
      <div class="warning-badge">⚠️</div>
    </div>
    
    <!-- Error Content -->
    <div class="error-content">
      <h1 class="error-title">{{ 'NOT_FOUND_TITLE' | translate }}</h1>
      <h2 class="error-subtitle">{{ 'NOT_FOUND_SUBTITLE' | translate }}</h2>
      <p class="error-message">{{ 'NOT_FOUND_MESSAGE' | translate }}</p>
    </div>
    
    <!-- Action Buttons -->
    <div class="action-buttons">
      <button type="button" class="btn primary-btn" (click)="goHome()">
        <span class="btn-icon">🏠</span>
        {{ 'ACCESS_DENIED_GO_HOME' | translate }}
      </button>
      
      <button type="button" class="btn secondary-btn" (click)="goBack()">
        <span class="btn-icon">↩️</span>
        {{ 'ACCESS_DENIED_GO_BACK' | translate }}
      </button>
    </div>
    
    <!-- Additional Info -->
    <div class="additional-info">
      <p class="info-text">{{ 'ACCESS_DENIED_HELP_TEXT' | translate }}</p>
    </div>
    
  </div>
</div>
